var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup33(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_1707)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2695 14.9074C16.002 14.5705 15.5676 14.0824 15.1957 14.0362C14.9695 14.008 14.7095 14.1955 14.4532 14.3724C14.4032 14.3974 14.017 14.6274 13.9701 14.6412C13.7226 14.7118 13.1945 14.7324 12.8751 14.4412C12.5676 14.1599 12.0813 13.6393 11.6888 13.1624C11.3138 12.6712 10.9207 12.0805 10.7195 11.718C10.5095 11.3424 10.6607 10.8455 10.7907 10.6268C10.8145 10.5874 11.102 10.2918 11.1663 10.223L11.1757 10.2343C11.4138 10.0343 11.6632 9.83117 11.6913 9.61117C11.7376 9.24492 11.3632 8.71179 11.0957 8.37429C10.8282 8.03617 10.4138 7.44429 9.84946 7.52804C9.63696 7.55929 9.45383 7.63367 9.27321 7.74054L9.26821 7.73492C9.26446 7.73742 9.24696 7.75117 9.23821 7.75804C9.23258 7.76117 9.22758 7.76304 9.22258 7.76617L9.22446 7.76867C9.12071 7.84867 8.82446 8.06992 8.79071 8.09992C8.42446 8.42554 7.87321 9.19242 8.29946 10.5718C8.61571 11.5968 9.29008 12.8005 10.2088 14.018L10.2038 14.0224C10.2488 14.0812 10.2951 14.1343 10.342 14.1912C10.3857 14.2493 10.4288 14.3068 10.4738 14.3643L10.4801 14.3599C11.4551 15.5343 12.4776 16.473 13.4107 17.0268C14.667 17.7718 15.5601 17.4362 15.9726 17.1693C16.0113 17.1437 16.3063 16.9143 16.4063 16.8387L16.4088 16.8412C16.4126 16.8374 16.4151 16.8324 16.4201 16.8287C16.4276 16.823 16.4438 16.8105 16.447 16.808L16.4432 16.803C16.5945 16.6568 16.7157 16.5005 16.7995 16.3037C17.0188 15.7855 16.537 15.2455 16.2695 14.9074Z",
    fill: "#064A72"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_1707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(7.5 7.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup33);
export default __webpack_public_path__ + "static/media/Group 33.af7ab9854e8920553058d27062935be5.svg";
export { ForwardRef as ReactComponent };